/**
 * EXTCWP-565: This ensures that the Twitter handle is always prefixed with '@' as by
 * Feb. 2025 datasource entries can no longer have a value that starts with '@'.
 *
 * @param {string} twitterHandle the user's twitter handle
 */
export const fixTwitterHandle = (twitterHandle: string | undefined): string => {
  if (!twitterHandle || twitterHandle.length === 0) {
    return '';
  }
  if (!twitterHandle.startsWith('@')) {
    return `@${twitterHandle}`;
  }
  return twitterHandle;
};
